import { ReceptionDetailSummary } from "../list";

// 依頼詳細検索結果model
export class ReceptionDetailSearchResult {
  public list: ReceptionDetailSummary[];
  public overLimitMessage: string;
}
